import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { CompanyTierSetting } from '../models/company-tier-setting';

@Injectable({
  providedIn: 'root',
})
export class CompanyTierSettingService {
  private http = inject(HttpClient);

  public async getCompanyTier(companyId: string): Promise<CompanyTierSetting> {
    return await this.http.get<CompanyTierSetting>(`company-tier-setting/${companyId}`).toPromise();
  }

  public async canAddShippingCarriers(companyId: string): Promise<boolean> {
    return await this.http.get<boolean>(`company-tier-setting/can-add-new-carriers/${companyId}`).toPromise();
  }

  public async isBulkPickingEnabled(companyId: string): Promise<boolean> {
    return await this.http.get<boolean>(`company-tier-setting/bulk-picking-status/${companyId}`).toPromise();
  }

  public async isInventoryEnabled(companyId: string): Promise<boolean> {
    return await this.http.get<boolean>(`company-tier-setting/inventory-status/${companyId}`).toPromise();
  }

  public async isOrderReceivedMessageEnabled(companyId: string): Promise<boolean> {
    return await this.http.get<boolean>(`company-tier-setting/order-received-message-status/${companyId}`).toPromise();
  }

  public async getOrderReceivedMessageTemplate(companyId: string): Promise<string | null> {
    return await this.http
      .get<string | null>(`company-tier-setting/order-received-message-template/${companyId}`)
      .toPromise();
  }

  public async getOrderShippedMessageTemplate(companyId: string): Promise<string | null> {
    return await this.http
      .get<string | null>(`company-tier-setting/order-shipped-message-template/${companyId}`)
      .toPromise();
  }

  public async isDefaultCarriersContractsEnabled(companyId: string): Promise<boolean> {
    return await this.http
      .get<boolean>(`company-tier-setting/default-carriers-contracts-status/${companyId}`)
      .toPromise();
  }

  public async isDigitalScaleEnabled(companyId: string): Promise<boolean> {
    return await this.http.get<boolean>(`company-tier-setting/digital-scale-status/${companyId}`).toPromise();
  }

  public async isCombineOrdersEnabled(companyId: string): Promise<boolean> {
    return await this.http.get<boolean>(`company-tier-setting/combine-orders-status/${companyId}`).toPromise();
  }

  public async isDraftOrdersEnabled(companyId: string): Promise<boolean> {
    return await this.http.get<boolean>(`company-tier-setting/draft-orders-status/${companyId}`).toPromise();
  }

  public async isLocalPickupScreenEnabled(companyId: string): Promise<boolean> {
    return await this.http.get<boolean>(`company-tier-setting/local-pickup-screen-status/${companyId}`).toPromise();
  }
}
